export const MANAGE_EXPIRATION = "persitentAlert/manageExpiration";
export const MANAGE_PAYMENT_DUE = "persitentAlert/managePaymentDue";
